import React, { Component, Fragment } from "react";
import { currentLocals } from "../../languages/languages.js";
import HeaderMui from "../../containers/HeaderMuiContainer";
import ConvertersPannel from "../../containers/ConvertersPannelContainer";
import ConverterManager from "../../containers/ConverterManagerContainer";
import ConversionPanel from "../../containers/ConversionPanelContainer";
import OnBoarding from "../../containers/OnBoardingContainer";
import Cookies from "universal-cookie";
import MessageNoAccess from "../header/MessageNoAccess.js";
export default class Main extends Component {
  constructor() {
    super();

    this.AfterLoadCreateDefaultMdl_V7Converter = this.AfterLoadCreateDefaultMdl_V7Converter.bind(this);
    this.CreateDefaultMdl_V7Converter = this.CreateDefaultMdl_V7Converter.bind(this);
    this.AddDefaultNConverters = this.AddDefaultNConverters.bind(this);
    this.deleteAllCookies = this.deleteAllCookies.bind(this);
    this.getUrlEnv = this.getUrlEnv.bind(this);
    this.getEnvironmentFromProcessEnvOrProp = this.getEnvironmentFromProcessEnvOrProp.bind(this);
    this.getForbiddenPageUrl = this.getForbiddenPageUrl.bind(this);
    // vesion control
    const cookies = new Cookies();
    const CurrentVersion = "2023.02.28";
    let noMoreWelcome = cookies.get("noMoreWelcome");
    let PaCoVersion = cookies.get("PaCoVersion");

    // to show "What's New" when a new version is deployed

    if (PaCoVersion !== CurrentVersion) {
      //if (noMoreWelcome === "3") cookies.set("noMoreWelcome", "2", { path: "/" });
      window.localStorage.setItem("on_boarding", "true");
    }

    // set version

    //cookies.set("PaCoVersion", "2023.02.28", { path: "/" });

    document.cookie = "PaCoVersion=" + CurrentVersion;
    //document.cookie = "PaCoVersion=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    //document.cookie = "PaCoVersionJS=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    //this.deleteAllCookies();
  }
  FunctionsAfterLoad() {}
  deleteAllCookies() {
    const cookies = document.cookie.split(";");

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
  }
  //////////////////////////////////////////////////////////////////////////

  AfterLoadCreateDefaultMdl_V7Converter() {
    this.CreateDefaultMdl_V7Converter();
  }
  CreateDefaultMdl_V7Converter() {
    const { getConverters } = this.props;
    //getConverters ya crea por defecto el V7 si procede
    getConverters();
    //Leemos si se han creado conversores por defecto. Los leemos de la gateway a través de un API
  }

  AddDefaultNConverters(Converters) {
    const { addNConverters } = this.props;

    addNConverters({ Converters: Converters });
  }

  AddDefaultConverter(idPar, type, typeDestination, typeInOut) {
    const { addConverter, converters } = this.props;

    let newid = "converter1";
    for (let ndx = 1; ndx < 100; ndx++) {
      newid = "converter" + ndx;
      if (converters.findIndex((converter) => converter.id === newid) < 0) break;
    }
    let mytypeOrigin, mytypeDestination, mytypeInOut;
    mytypeOrigin = type; //default type
    mytypeDestination = typeDestination;
    mytypeInOut = typeInOut;
    addConverter({
      id: idPar,
      type: mytypeOrigin,
      typeDestination: mytypeDestination,
      typeInOut: mytypeInOut,
    });
    //closeConfig();
  }

  getUrlEnv(env) {
    switch (env.toUpperCase()) {
      case "DEV":
        return ".dev";
      case "TEST":
        return ".test";
      case "PROD":
        return "";
      default:
        return "";
    }
  }

  getEnvironmentFromProcessEnvOrProp() {
    let REACT_APP_AUTH0_DOMAIN = "REACT_APP_AUTH0_DOMAIN";
    //let PROCESS_ENVIRONMENT_VARIABLE = "REACT_APP_ENVIRONMENT";
    //const envFromProcess = env ?? process?.env[PROCESS_ENVIRONMENT_VARIABLE];
    let envFromProcess = "";
    let ProcessDomain = process.env[REACT_APP_AUTH0_DOMAIN];

    if (ProcessDomain.indexOf(".dev.") > 0) envFromProcess = "DEV";
    else if (ProcessDomain.indexOf(".test.") > 0) envFromProcess = "TEST";
    else envFromProcess = "PROD";
    //alert(envFromProcess);
    //if (!envFromProcess) return "";

    return this.getUrlEnv(envFromProcess);
  }

  getForbiddenPageUrl(locale, environment) {
    let PageURL = `https://assets${this.getEnvironmentFromProcessEnvOrProp(environment)}.mylectra.com/403/${
      locale ? `${locale}/` : ""
    }index.html`;
    return PageURL;
  }
  //////////////////////////////////////////////////////////////////////////
  /* Lo comentamos. Ahora dejamos la función de crear conversores en la saga de converters.*/

  render() {
    console.log("Main->Parametro conectado, desde el Main " + this.props.connected);
    //Decidimos, en base a las cookies, si mostramos , WhatIsNew....

    const appTitle = {
      label: currentLocals(this.props.locale).general.Pattern_Converter,
      action: () => this.navigate("/summary"),
    };

    /*
  const getForbiddenPageUrl = (locale: string | undefined, environment: Env | undefined) =>
  `https://assets${getEnvironmentFromProcessEnvOrProp(environment)}.mylectra.com/403/${
    locale ? `${locale}/` : ""
  }index.html`;

  */
    //alert(this.props.locale);
    var delayInMilliseconds = 10000; //200 miliseconds

    /*
    setTimeout(function () {
      //your code to be executed after 200 miliseconds
      console.log("setTimeout");
      //let algo = algo + 1;
    }, delayInMilliseconds);*/

    if (this.props.authnoaccess) {
      //Hacemos un logout
      const { logout } = this.props;
      //logout();
      /*
      window.location.assign(this.getForbiddenPageUrl(this.props.locale, this.getEnvironmentFromProcessEnvOrProp()));
      console.log("Logout en MAIN");
      logout();
      //return;
      */

      return (
        <MessageNoAccess
          noaccess="true"
          requiredpermissions="requiredpermissions"
          currentpermissions="currentpermissions"
        ></MessageNoAccess>
      );
    } else
      return (
        <Fragment>
          <div style={{ position: "fixed", top: 0, width: "100%", zIndex: "100" }}>
            <HeaderMui></HeaderMui>
          </div>
          <div></div>

          <div id="main" style={{ position: "relative", top: 37, width: "100%" }}>
            <ConverterManager />
            <ConvertersPannel></ConvertersPannel>
            <ConversionPanel />
          </div>
          {<OnBoarding></OnBoarding>}
        </Fragment>
      );
  }
}
